import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import useIsFeatureAvailable from 'hooks/useIsFeatureAvailable';
import type { ServicesType } from 'utils/globalTypes';

type Props = {
  children: ReactNode;
  service: ServicesType;
  agentCheckRequired?: boolean;
};

function PrivateRoute({ children, service, agentCheckRequired = true }: Props) {
  const isUserHasFeature = useIsFeatureAvailable(service, agentCheckRequired);

  if (isUserHasFeature) {
    return children;
  }

  return <Navigate to='/dashboard' replace />;
}

export default PrivateRoute;
